// children Li must have padding. Grey separator (border) between each Li. Li must have display flex with justifyContent: space-between.
import { Variant } from '@kizi/core-components';
import p from './paragraphs';

const accordionPrimary = {
  '& > li': {
    paddingTop: '33px',
    paddingBottom: '33px',
    borderBottom: '1px solid',
    borderColor: 'second.1',
    color: 'text',
    fontWeight: 600,
  },
  '& ul li': {
    fontWeight: 'normal',
  },
  '& > li:last-child': {
    borderBottom: 'none',
  },
};

const innerProductTabAccordion = {
  '& > li': {
    py: 3,
    borderBottom: '1px solid',
    borderColor: 'second.1',
    ...p.footnoteRegular,
    '& > p': {
      pt: 3,
    },
  },
  '& ul li': {
    fontWeight: 'bold',
  },
  '& > li:last-child': {
    borderBottom: 'none',
  },
};

const accordionProductInner: Variant = {
  color: 'main.2',
  'ul:last-of-type > li:last-of-type': {
    borderBottom: 'none',
  },
  '> li': {
    fontSize: 2,
    '> div:first-of-type': {
      ...p.bodyRegular,
      pb: 3,
    },
    '> p': {
      m: 0,
    },
    '&:nth-of-type(2)': {
      mt: 6,
    },
  },
};

const accordionProductMobile: Variant = {
  '> li': {
    fontSize: 2,
    py: 3,
    borderBottom: '1px solid',
    borderColor: 'second.1',
    '&:last-child': {
      borderBottom: 'none',
    },
    label: {
      color: 'main.1',
      mb: 0,
      '&.selected': {
        fontWeight: 1,
      },
    },
    '> div > div': {
      '&:first-of-type': {
        mt: 3,
      },
      '&:not(:first-of-type)': {
        mt: 6,
      },
    },
    '> ul': {
      ...accordionProductInner,
    },
  },
};

const accordionProductList = {
  li: {
    borderBottom: '1px solid',
    borderColor: 'second.1',
    color: 'main.2',
    display: 'flex',
    justifyContent: 'space-between',
    '&:not(:first-of-type)': {
      pt: 3,
    },
    '&:not(:last-of-type)': {
      pb: 3,
    },
    '&:last-child': {
      borderBottom: 'none',
    },
  },
};

const prosConsAccordion = {
  '&:last-of-type > li:last-of-type': {
    borderBottom: 'none',
  },
  '& > li': {
    py: 3,
    borderBottom: '1px solid',
    borderColor: 'second.1',
    color: 'text',
    '& :last-child': {
      borderBottom: 'none',
    },
    '& > div:not(:first-child)': {
      mt: 1,
      p: {
        ...p.footnoteRegular,
        mx: 6,
      },
    },
  },
  '& ul li': {
    fontWeight: 'normal',
  },
};

const accordionInnerModal = {
  ...accordionPrimary,
  '& > li': {
    py: 3,
    borderBottom: '1px solid',
    borderColor: 'second.1',
    color: 'text',
    fontWeight: 400,
  },
};

const accordionInnerModalSmall = {
  ...accordionPrimary,
  '& > li': {
    py: 2,
    borderBottom: '1px solid',
    borderColor: 'second.1',
    color: 'text',
    fontWeight: 400,
  },
};

const unorderedList = {
  listStyle: 'disc',
  marginLeft: 4,
  '& > li': {
    my: 3,
    ':first-child': {
      marginTop: 0,
    },
    ':last-child': {
      marginBottom: 0,
    },
  },
};

const termsList = {
  li: {
    marginTop: 3,
    color: 'main.1',
    svg: {
      fill: 'main.1',
      marginRight: 2,
    },
    a: {
      textDecoration: 'none',
    },
  },
};

const tariffsOverlayProductDetails = {
  '> li': {
    fontSize: 3,
    '> div:first-of-type': { fontWeight: 1, pb: 3 },
    '> p': {
      m: 0,
    },
    '&:nth-of-type(2)': {
      mt: 6,
    },
  },
};

const accordionInnerList = {
  color: 'text',
  '& > li': {
    ...p.bodyRegular,
    py: 3,
    borderBottom: '1px solid',
    borderColor: 'second.1',
    display: 'flex',
    flexDirection: ['column', 'row'],
    justifyContent: ['flex-start', 'space-between'],
  },
  '& > li:last-child': {
    borderBottom: 'none',
    pb: 0,
  },
  '& > li:first-child': {
    pt: 5,
  },
};

const comparisonProductListItems = {
  color: 'main.2',
  '> li': {
    fontSize: 2,
  },
  borderTop: '1px solid',
  borderColor: 'second.1',
  paddingTop: 3,
};

const comparisonProductListItem = {
  li: {
    display: 'flex',
    justifyContent: 'space-between',
    '&:not(:last-of-type)': {
      pb: 3,
    },
  },
};

const secondary = {
  color: 'text',
  '& > li': {
    py: 3,
    borderBottom: '1px solid',
    borderColor: 'second.1',
    display: ['block', 'flex'],
    justifyContent: 'space-between',
  },
  '& > li:last-child': {
    borderBottom: 'none',
  },
};

const applyPageTermsAndPoliciesList = {
  ...p.bodyRegular,
  '> ul': {
    pl: 6,
    '> li': {
      '> a': {
        color: 'main.1',
        textDecoration: 'underline',
      },
    },
  },
};

const lists = {
  primary: {
    color: 'text',
    '& > li': {
      py: 3,
      borderBottom: '1px solid',
      borderColor: 'second.1',
      display: 'flex',
      justifyContent: 'space-between',
    },
    '& > li:last-child': {
      borderBottom: 'none',
    },
  },
  secondary,
  accordionInnerList,
  accordionPrimary,
  accordionProductInner,
  accordionProductMobile,
  accordionProductList,
  accordionProductListPrice: {
    ...accordionProductList,
    li: {
      ...accordionProductList.li,
    },
  },
  innerProductTabAccordion,
  accordionInnerModal,
  accordionInnerModalSmall,
  prosConsAccordion,
  unorderedList,
  termsList,
  tariffsOverlayProductDetails,
  comparisonProductListItems,
  comparisonProductListItem,
  applyPageTermsAndPoliciesList,
};

export default lists;
